// @core/api/endpoints/authn/exchange_channel_token.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExchangeChannelTokenRequest,
  TokenResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Exchange a channel identity for tokens
 * A trusted channel adapter (Telegram/MAX) asserts a platform user identity (provider + external user id), authenticated by client credentials. Finds the linked account or provisions one, then returns tokens. Enables one account across web and messaging channels.
 * @public This endpoint does not require authentication
 */
export async function ExchangeChannelToken(
  data: ExchangeChannelTokenRequest,
  options?: RequestOptions
): Promise<TokenResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/channel/token`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<TokenResponse>(requestPath, data, requestOptions);
}
